module.exports = __webpack_public_path__ + "media/images/country_flags/mn-f21153ed7fe70ba64d08709ef00b8723.png";